import React from 'react';
import Select from 'react-select';

export default class DriverDropdown extends React.Component {
	state = {
		selectedOption: null,
	};

	handleChange = (event) => {
		this.setState({
			selectedOption: event,
		});

		this.props.handleDriverChange(event);
	}

	componentDidUpdate = (prevProps) => {
		if (prevProps.selectedDriver && prevProps.selectedDriver !== this.props.selectedDriver) {
			this.setState({ selectedOption: this.props.selectedDriver });
		}
	}

	render() {
		const data = [];
		let isDisabled = true;

		this.props.drivers.forEach(driver => {
			const d = {
				value: driver.driverId,
				label: driver.driverName,
				driver: driver,
			};
			data.push(d);
		})

		if (data.length > 0) {
			isDisabled = false;
		}

		const selectDriverStyles = {
			option: (styles, { isDisabled }) => {
				return {
					...styles,
					color: '#394b59',
					cursor: isDisabled ? 'not-allowed' : 'default',

					':active': {
						...styles[':active'],
					},
				};
			},
			singleValue: (provided, state) => {
				const opacity = state.isDisabled ? 0.5 : 1;
				const transition = 'opacity 300ms';

				return { ...provided, opacity, transition };
			},
			placeholder: (state) => ({
				color: state.isSelected ? 'black' : '#394b59',
			})

		}

		const selectedDriver = data.find(d => d.value === this.state.selectedOption?.value);

		return (
			<Select
				styles={selectDriverStyles}
				value={selectedDriver}
				onChange={this.handleChange}
				options={data}
				isDisabled={isDisabled}
				theme={theme => ({
					...theme,
					borderRadius: 0,
					colors: {
						...theme.colors,
						primary25: 'lightgrey',
					},
				})}
			/>
		);
	}
}
